<template>
  <div id="app">
    <AdminPendingTenants v-if="router.currentRoute === 'admin'" />
    <PublicGuestPersonRegister
      v-else-if="router.currentRoute === 'guest-person-register'"
      :token="router.params.token"
    />
    <PublicContractSign
      v-else-if="router.currentRoute === 'contract-sign'"
      :token="router.params.token"
    />
    <PublicOwnerContractDraw
      v-else-if="router.currentRoute === 'owner-contract-draw'"
      :token="router.params.token"
    />
    <Landing
      v-else-if="!isLoggedIn && (router.currentRoute === 'dashboard' || router.currentRoute === 'about')"
      :landing-section="router.currentRoute === 'about' ? 'about' : 'showcase'"
      @auth-success="handleAuthSuccess"
    />
    <PropertyDetail v-else-if="!isLoggedIn && router.currentRoute === 'property-detail'" :propertyId="router.params.id" @back="backToLanding" />
    <Home v-else :user="currentUser" @user-updated="updateCurrentUser" />
  </div>
</template>

<script>
import Home from './components/Home.vue'
import Landing from './components/Landing.vue'
import PropertyDetail from './components/PropertyDetail.vue'
import PublicGuestPersonRegister from './components/PublicGuestPersonRegister.vue'
import PublicContractSign from './components/PublicContractSign.vue'
import PublicOwnerContractDraw from './components/PublicOwnerContractDraw.vue'
import AdminPendingTenants from './components/AdminPendingTenants.vue'
import { router, navigateTo } from './router'
import {
  applyDefaultPageMeta,
  applyAboutPageMeta,
  applyAdminPageMeta,
  applyPropertySkeletonMeta
} from './utils/pageMeta'

export default {
  components: {
    Home,
    Landing,
    PropertyDetail,
    PublicGuestPersonRegister,
    PublicContractSign,
    PublicOwnerContractDraw,
    AdminPendingTenants
  },

  data() {
    return {
      isLoggedIn: false,
      currentUser: null,
      router: router
    }
  },

  mounted() {
    const userToken = localStorage.getItem('userToken')
    const user = localStorage.getItem('user')
    if (userToken && user) {
      this.currentUser = JSON.parse(user)
      this.isLoggedIn = true
    }
    this.syncPublicHead()
  },

  watch: {
    'router.currentRoute'() {
      this.syncPublicHead()
    },
    isLoggedIn() {
      this.syncPublicHead()
    }
  },

  methods: {
    /** Meta tags para visitante / admin (área logada trata em Home.vue) */
    syncPublicHead() {
      if (this.isLoggedIn) return

      const r = this.router.currentRoute
      if (r === 'guest-person-register') {
        document.title = 'Cadastro de dados | TripDay'
        return
      }
      if (r === 'contract-sign') {
        document.title = 'Contrato | TripDay'
        return
      }
      if (r === 'owner-contract-draw') {
        document.title = 'Rubrica e assinatura | TripDay'
        return
      }
      if (r === 'admin') {
        applyAdminPageMeta()
        return
      }
      if (r === 'about') {
        applyAboutPageMeta()
        return
      }
      if (r === 'property-detail') {
        applyPropertySkeletonMeta()
        return
      }
      applyDefaultPageMeta()
    },

    handleAuthSuccess(data) {
      this.currentUser = data.user
      this.isLoggedIn = true
    },

    updateCurrentUser(user) {
      this.currentUser = user
      if (user) {
        localStorage.setItem('user', JSON.stringify(user))
      }
    },

    backToLanding() {
      navigateTo('dashboard', {})
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f9fafb;
}
</style>
